// @ts-nocheck
import React from 'react';
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import {setupInterceptorsTo} from "../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import SinapThemev2 from "../styles/SinapThemev2";
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Grow from '@mui/material/Grow';
import Alert from '@mui/material/Alert';
import {ExpandAvatar} from "../Body/Home";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import CircularIndeterminate from "../Componentes/CircularIndeterminate";
import PasswordIcon from '@mui/icons-material/Password';
import LockIcon from '@mui/icons-material/Lock';
import { useTheme } from '@mui/material/styles';
import LoginIcon from '@mui/icons-material/Login';
import {RUTA_API_ALIAS, RUTA_API_USUARIOS} from "../Contantes/Constantes";
import {useBody} from "../Body/state/BodyContext";
import {useUsuarios} from "./State/UsuarioContext";
import Keycloak from "../Auth/Keycloak";



const useStyles = makeStyles(theme => ({
    typografy:{
        marginTop: '2%',
        width: "100%",
        color: SinapThemev2.palette.primary.main,
    }
}))

const steps = ['Ingresar Correo', 'Revisar correo', 'Ingresar nueva contraseña', 'Paso final'];


const delay = 5;

function CircularDone({...props}){
    const [done, setDone] = React.useState(false)

    React.useEffect(() => {
        let timer1 = setTimeout(() => setDone(true), delay * 1000);

        // this will clear Timeout
        // when component unmount like in willComponentUnmount
        // and show will not change to true
        return () => {
            clearTimeout(timer1);
        };
    } ,[])

    return (
        <>
            {done ? null : <CircularIndeterminate/>}
        </>
    )

}

export default function ResetPassword({...props}){
    const classes= useStyles();
    const theme = useTheme();
    const [uuid,setUuid] = React.useState(null);
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const {setSuccess,setMessage,loadingBackdrop,setLoadingBackdrop} = useBody();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [errorMsg, setErrorMsg] = React.useState("");
    const [error, setError] = React.useState(0);
    const [email,setEmail] = React.useState("");
    const [emailErrorMessage,setEmailErrorMessage] = React.useState("");
    const searchParams = new URLSearchParams(document.location.search)
    const {fetchEstadoUsuarioEnLDAP} = useUsuarios()

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const [showPassword, setShowPassword] = React.useState(false);


    const handleValidation= async (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        //for password
        if(passwordInputFieldName==='password'){
            const uppercaseRegExp   = /(?=.*?[A-Z])/;
            const lowercaseRegExp   = /(?=.*?[a-z])/;
            const digitsRegExp      = /(?=.*?[0-9])/;
            const minLengthRegExp   = /.{12,}/;
            const passwordLength =      passwordInputValue.length;
            const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
            const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
            const digitsPassword =      digitsRegExp.test(passwordInputValue);
            const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
            let errmsg ="";
            if(passwordLength===0){
                errmsg="La contraseña no puede ser vacia"
                await setError(1)
            }else if(!uppercasePassword){
                errmsg="La contraseña debe tener al menos una letra mayuscula";
                await setError(1)
            }else if(!lowercasePassword){
                errmsg="La contraseña debe tener al menos una letra minuscula";
                await setError(1)
            }else if(!digitsPassword){
                errmsg="La contraseña debe tener al menos un digito";
                await setError(1)
            }else if(!minLengthPassword){
                errmsg="La contraseña debe tener al menos 12 carácteres";
                await setError(1)
            }else{
                errmsg="";
                await setError(0)
            }
            setErrorMsg(errmsg);

        }
    }
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async (e) => {
            if (!email.trim().toLowerCase().endsWith('@frba.utn.edu.ar')) {
                setEmailErrorMessage('Debe ingresar un correo terminado en @frba.utn.edu.ar')
                return
            }

            setLoadingBackdrop(true)

            const response = await axios({
                method: 'GET',
                url: `${RUTA_API_USUARIOS}/ldap/users/account/${email.split('@')[0]}/suspended`
            })

            const isSuspended = response.data;

            if (isSuspended) {
                setEmailErrorMessage('La cuenta del usuario ingresado se encuentra suspendida.')
                setLoadingBackdrop(false)
                return
            }

            setEmailErrorMessage("")

            await axios({
                method: 'POST',
                url: RUTA_API_USUARIOS + `/solicitudes/recuperate/password/`,
                data: {
                    uidSolicitante: email.split('@')[0]
                }
            }).then(response => {
                setLoadingBackdrop(false)
                handleNext();
            }).catch(error => setMessage("Hubo un error al querer enviar el mail (Código de error: 00054)"));
    }

    const handlePassword = async () => {
        if(password !== confirmPassword){
            setMessage('Las contraseñas con coinciden')
            return
        }
        if(error === 0) {
            setLoadingBackdrop(true)
            await axios({
                method: 'PUT',
                url: RUTA_API_USUARIOS + `/ldap/users/recuperar/password/${uuid}`,
                data: {
                    password: password
                }
            }).then(response => {
                handleNext();
                setLoadingBackdrop(false)
            }).catch(error => {
                if (error.response.status !== 400)
                    setMessage("Hubo un error al querer enviar el mail (Código de error: 00054)")
                else {
                    setErrorMsg(error.response.data)
                    setError(1)
                }
                setLoadingBackdrop(false)
            });
        }
        else
            setMessage("No se pudo cambiar la contraseña porque no cumple las condiciones necesarias")
    }
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const checkUuidResetPassword = async (uuid) => {
        setLoadingBackdrop(true)
        await axios({
            method: 'GET',
            url: RUTA_API_USUARIOS + `/solicitudes/recuperate/password/${uuid}/isvalid`,
        }).then(response => {
            setActiveStep(2)
            setLoadingBackdrop(false)
        }).catch(error => {
            setActiveStep(0)
            setLoadingBackdrop(false)
        });
    }

    React.useEffect( () => {
        const uuid_url = searchParams.get('uuid');

        if (uuid_url){
            checkUuidResetPassword(uuid_url)
            setUuid(uuid_url);
        }
    },[])

    const handleKeypress = e => {
        if (e.key === 'Enter') { setLoadingBackdrop(true)
            handleSubmit().then(r => setLoadingBackdrop(false));
        }  };

    const EnterPressConfirmPasswordChange = e => {
        if (e.key === 'Enter') { setLoadingBackdrop(true)
            handlePassword().then(r => setLoadingBackdrop(false));
        }
    }


    const handleReset = () => {
        setActiveStep(0);
    };

    const activeStepTemplate = (step) => {
        switch(step){
            case 0:
                return(
                    <Box>
                        <ExpandAvatar style={{display: 'flex',
                            justifyContent: 'center'}}><Avatar sx={{ bgcolor: SinapThemev2.palette.secondary.light }}><ForwardToInboxIcon/> </Avatar></ExpandAvatar>
                        <br/>
                        <Typography align='center' sx={{ mt: 2, mb: 1 }} variant={matches ? 'h5' : 'h4'}>Ingresar correo</Typography>
                        <br/>
                        <Grid container
                              direction="column"
                              justifyContent="center"
                              alignItems="strech"
                              spacing={2}>
                            <Grid item xs={12}>
                                <Box sx={{ width: '80%', marginLeft: '10%'}}>

                                    <Alert severity="info">
                                        Si usted olvidó su contraseña, puede recuperarla siguiendo estos pasos:<br/>
                                        <ul>
                                            <li>Complete el formulario de abajo ingresando su usuario SInAp o su cuenta institucional FRBA.</li>
                                            <li>Le llegará un e-mail a su correo alternativo con una serie de pasos a seguir.</li>
                                            <li>Una vez confirmado el deseo de regenerar su password, se le enviará otro e-mail informandole un nuevo password generado por el sistema. Por su seguridad, le aconsejamos que lo cambie más tarde.</li>
                                        </ul>
                                    </Alert>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ width: '50%', marginLeft: '25%'}}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">Ingrese su correo FRBA o usuario institucional</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type= {'text'}
                                            label="Ingrese su correo FRBA o usuario institucional"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}
                                            onKeyPress={handleKeypress}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{display: 'flex', alignContent: 'center', justifyContent: 'center'}}>
                                    <Button type="submit" variant="contained" onClick={handleSubmit}> Enviar Correo </Button>
                                </Box>
                            </Grid>
                            <Grid item >
                            </Grid>
                            {emailErrorMessage && 
                                <Grid item >
                                    <Typography align='center' variant='subtitle1' color="error">{emailErrorMessage}</Typography>
                                </Grid>
                            }
                            <br/>
                        </Grid>
                    </Box>
                )
            case 1:
                return (
                    <Box>
                        <ExpandAvatar style={{display: 'flex',
                            justifyContent: 'center'}}><Avatar sx={{ bgcolor: SinapThemev2.palette.secondary.light }}><MarkEmailReadIcon/> </Avatar></ExpandAvatar>
                        <br/>
                        <Typography align='center' sx={{ mt: 2, mb: 1 }} variant={matches ? 'h5' : 'h4'}>Revisar correo</Typography>
                        <br/>
                        <Grid container
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={2}>
                            <Grid item xs={12}>
                                <Box sx={{ width: '80%', marginLeft: '10%'}}>
                                    <Typography align='center' variant='subtitle1'>Te enviaremos un correo electrónico con un enlace para crear su nueva contraseña para su usuario institucional.</Typography>
                                </Box>
                            </Grid>
                            <Grid item>
                                    <br/>
                                    <CircularDone/>
                                    <br/>
                            </Grid>
                        </Grid>
                    </Box>
                )
            case 2:
                return (
                    <Box>
                        <ExpandAvatar style={{display: 'flex',
                            justifyContent: 'center'}}><Avatar sx={{ bgcolor: SinapThemev2.palette.secondary.light }}><PasswordIcon/> </Avatar></ExpandAvatar>
                        <br/>
                        <Typography align='center' sx={{ mt: 2, mb: 1 }} variant={matches ? 'h5' : 'h4'}>Ingresar nueva contraseña</Typography>
                        <br/>
                        <Grid container
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={2}>
                            <Grid item xs={12}>
                                {error ? <Alert severity="error">
                                    {errorMsg}
                                </Alert> : null}
                            </Grid>
                            <Grid item xs={12}>
                                <Box>
                                    <FormControl error={error} variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">Nueva contraseña</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            error={error}
                                            type={showPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                        size="large">
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Nueva contraseña"
                                            name="password"
                                            value={password}
                                            onChange={e => {
                                                setPassword(e.target.value)
                                                handleValidation(e)
                                            }}
                                            onKeyPress={EnterPressConfirmPasswordChange}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box >
                                    <FormControl variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">Repetir contraseña</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type={showPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword}
                                                        onMouseDown={handleMouseDownPassword}
                                                        edge="end"
                                                        size="large">
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Repetir contraseña"
                                            value={confirmPassword}
                                            onChange={e => setConfirmPassword(e.target.value)}
                                            onKeyPress={EnterPressConfirmPasswordChange}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box>
                                    <Button variant='contained' disabled={error} onClick={handlePassword}> Cambiar Contraseña </Button>
                                </Box>
                            </Grid>
                            <Grid item >
                                <br/>
                            </Grid>
                        </Grid>
                    </Box>
                );
            case 3:
                return (
                    <Box>
                        <ExpandAvatar style={{display: 'flex',
                            justifyContent: 'center'}}><Avatar sx={{ bgcolor: SinapThemev2.palette.secondary.light }}><LockIcon/> </Avatar></ExpandAvatar>
                        <br/>
                        <Typography align='center' sx={{ mt: 2, mb: 1 }} variant={matches ? 'h5' : 'h4'}>¡Contraseña Reestablecida!</Typography>
                        <br/>
                        <Grid container
                              direction="column"
                              justifyContent="center"
                              alignItems="center"
                              spacing={2}>
                            <Grid item xs={12}>
                                <Box sx={{ width: '80%', marginLeft: '10%'}}>
                                    <Typography align='center' variant='subtitle1'>Se reestableció su contraseña con exito, cualquier inconveniente comunicarse con </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box >
                                    <Button variant='contained' onClick={() => Keycloak.doLogin()} > Iniciar Sesión <LoginIcon/></Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                )
        }
    }

    return (
        <Box sx={matches ? { marginTop: '5%' } : null}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={SinapThemev2}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="stretch"
                    >
                        <Grid item xs={12}>
                            <Box sx={{ marginLeft: '25%' ,width: '50%' }}>
                                <Stepper activeStep={activeStep}>
                                    {steps.map((label, index) => {
                                        const stepProps = {};
                                        const labelProps = {};
                                        if (isStepSkipped(index)) {
                                            stepProps.completed = false;
                                        }
                                        return (
                                            <Step key={label} {...stepProps}>
                                                <StepLabel {...labelProps}>{!matches ? label : null}</StepLabel>
                                            </Step>

                                        );
                                    })}
                                </Stepper>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={matches ? {marginTop:'5%', width: '90%', marginLeft: '5%'} : { marginLeft: '25%' ,width: '50%' }}>
                                <Grow in={true}>
                                    <Paper elevation={3}>
                                        <br/>
                                        {activeStep === steps.length ? (
                                            <React.Fragment>
                                                <Typography sx={{ mt: 2, mb: 1 }}>
                                                    All steps completed - you&apos;re finished
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                                    <Box sx={{ flex: '1 1 auto' }} />
                                                    <Button onClick={handleReset}>Reset</Button>
                                                </Box>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {activeStepTemplate(activeStep)}
                                            </React.Fragment>
                                        )}
                                    </Paper>
                                </Grow>
                            </Box>
                        </Grid>
                    </Grid>
                </ThemeProvider>
            </StyledEngineProvider>
        </Box>
    );
}
